<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="管线名称"
        prop="pipelineName"
      >
        <a-input
          v-model="form.pipelineName"
          placeholder="请输入管线名称"
          :maxLength="20"
        />
      </a-form-model-item>
      <a-form-model-item
        label="管线颜色"
        prop="pipelineColor"
      >
        <a-input
          type="color"
          v-model="form.pipelineColor"
        />
      </a-form-model-item>
      <a-form-model-item
        label="所属客户"
        prop="customUserId"
      >
        <div class="customUser_id">
          <a-select
            v-model="form.customUserId"
            placeholder="请选择所属客户"
            allow-clear
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in customList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.companyName }}
            </a-select-option>
          </a-select>
          <a-icon
            type="plus-circle"
            class="customUser_t"
            @click="$refs.userForm.handleAdd()"
            :hidden="userAddHidden"
          />
        </div>
        <!--        <a-input type="select" v-model="form.customUserId" placeholder="请输入所属客户"/>-->
      </a-form-model-item>
      <a-form-model-item
        label="里程范围"
        prop="mileageRange"
      >
        <a-input
          v-model="form.mileageRange"
          placeholder="请输入里程范围"
          :maxLength="20"
        />
      </a-form-model-item>
      <a-form-model-item
        label="位置信息"
        prop="address"
      >
        <a-input
          v-model="form.address"
          placeholder="请输入位置信息"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item
        label="备注"
        prop="userName"
      >
        <a-input
          type="textarea"
          v-model="form.remark"
          placeholder="请输入备注"
          :maxLength="100"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <userForm
      ref="userForm"
      @ok="getCustomList"
    ></userForm>
  </a-drawer>
</template>

<script>
import { getPipeline, addPipeline, updatePipeline, userPage } from '@/api/saifuneng/pipeline'
import userForm from '../../../biz/user/modules/CreateForm.vue'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    userForm
  },
  data () {
    return {
      userAddHidden: true,
      submitLoading: false,
      formTitle: '',
      customList: [],
      // 表单参数
      form: {
        id: null,
        pipelineName: null,
        pipelineColor: '#000000',
        customUserId: undefined,
        mileageRange: null,
        address: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        pipelineName: [
          { required: true, message: '管线名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getCustomList(null)
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 点击添加数据
    handleTian () {

    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        pipelineName: null,
        pipelineColor: '#000000',
        customUserId: undefined,
        mileageRange: null,
        address: null,
        remark: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      if (this.$store.getters.roles.includes('admin')) {
        this.userAddHidden = false
      }
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      if (this.$store.getters.roles.includes('admin')) {
        this.userAddHidden = false
      }
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPipeline({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePipeline(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPipeline(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    getCustomList () {
      let query = {
        pageNum: 1,
        pageSize: 9999,
        userType: '04'
      }
      userPage(query).then(response => {
        console.log(response, 'response===========');
        this.customList = response.data.records
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }


  }
}
</script>
<style lang="less" scoped>
.customUser_id {
  display: flex;
  align-items: center;

  .customUser_t {
    font-size: 20px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
